import { filterDropDownList } from "./DropdownUtils";

export const toggleFieldVisibilityWithLabel = (formData, { dataFieldValue, triggerMap, targetFieldId}) => {
const matchedTrigger = triggerMap[dataFieldValue?.find(item => triggerMap[item])];
const shouldShow = Boolean(matchedTrigger);

  let updatedFormData = {
    ...formData,
    formFields: formData.formFields.map((field) => {
      if (field.id === targetFieldId) {
        return {
          ...field,
          lable: shouldShow ? matchedTrigger : field.lable,
          Field_Name: shouldShow ? matchedTrigger : field.Field_Name,
          fieldSetting:{
            ...field.fieldSetting,
            isDisable:shouldShow ? false : true
          },
          validation: shouldShow ? [{ type: "require" }] : [],
          style: {
            ...field.style,
            containerCss: shouldShow
              ? "col-md-6 mb-3"
              : "col-md-6 mb-3",
          }
        };
      }
      return field;
    }),

    initialState: {
      ...formData.initialState,
      [targetFieldId]: shouldShow
        ? formData.initialState[targetFieldId]
        : null,
    }
  };

  return updatedFormData;
};


export const applyProductServiceInitialState = ({ formData, dropdownData, orgCategory, productsAndServices, }) => {
  if (!orgCategory) return formData;

  const serviceOptions = dropdownData ? filterDropDownList(`org${orgCategory}`, dropdownData) : [];

  const triggerMap = { 12: "Others; Please specify", 18: "Others; Please specify", 38: "Others; Please specify", };
  const triggerValues = Object.keys(triggerMap).map((x) => Number(x));
  const labelText = triggerMap[productsAndServices] ?? "";

  return {
    ...formData,
    formFields: formData.formFields.map((field) => {
      if (field.id === "productsandServicesOfferedbyOrganisation") {
        return {
          ...field, fieldSetting: { ...field.fieldSetting, options: serviceOptions, },
        };
      }

      if (field.id === "otherproductsandServices") {
        if (triggerValues.includes(productsAndServices)) {
          return {
            ...field, lable: labelText, Field_Name: labelText, style: { ...field.style, containerCss: "col-md-6 mb-3" }, validation: [{ type: "require" }],
            fieldSetting:{
            ...field.fieldSetting,
            isDisable:false
          },
          };
        } else {
          return {
            ...field, style: { ...field.style, containerCss: "col-md-6 mb-3" }, validation: [], fieldSetting:{
            ...field.fieldSetting,
            isDisable:true
          },
          };
        }
      }
      return field;
    }),
  };
};